import { getSavedSearch } from './saved-searches-storage';

export const sortSavedSearchesResponseOnLatestTotalCount = (response) => {
    const savedSearches = response.savedSearches
        .map((savedSearch) => {
            const dataFromLocalStorage = getSavedSearch(savedSearch.id);

            return {
                ...savedSearch,
                totalItems: dataFromLocalStorage?.totalItems || 0
            };
        })
        .sort((a, b) => b.totalItems - a.totalItems);

    return { ...response, savedSearches };
};
